import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgClockFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-9-5v5.465l2.555 1.703a1 1 0 0 1-1.11 1.664l-3-2A1 1 0 0 1 11 13V7a1 1 0 1 1 2 0Z", fill: color }));
};
export default factorySvgIcon(SvgClockFilled);
//# sourceMappingURL=SvgClockFilled.js.map